<template>
  <article class="psk-card group">
    <button type="button" class="psk-card__media" @click="$emit('try', card)">
      <img
        v-if="card.image"
        :src="card.image"
        alt=""
        class="psk-card__img"
        loading="lazy"
      />
      <div
        v-else
        class="psk-card__img psk-card__img--placeholder bg-gradient-to-br"
        :class="card.thumbGradient || 'from-zinc-700 to-zinc-900'"
      ></div>
    </button>

    <div class="psk-card__body">
      <h3 class="psk-card__title" :title="card.title">{{ card.title }}</h3>
      <p class="psk-card__desc" :title="card.desc">{{ card.desc || '点击试试看，一键体验该 Skill' }}</p>

      <div class="psk-card__actions">
        <button
          type="button"
          class="psk-card__bookmark"
          :class="{ 'psk-card__bookmark--on': bookmarked }"
          :title="bookmarked ? '取消收藏' : '收藏到我的技能'"
          @click="$emit('toggle-bookmark', card)"
        >
          <i :class="bookmarked ? 'fas fa-bookmark' : 'far fa-bookmark'"></i>
        </button>
        <button type="button" class="psk-card__try" @click="$emit('try', card)">
          试试看
        </button>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'PlusSkillsMarketCard',
  props: {
    card: { type: Object, required: true },
    bookmarked: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.psk-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px;
  background: #161616;
  border: 1px solid rgba(255, 255, 255, 0.06);
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.psk-card:hover {
  background: #1c1c1c;
  border-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.psk-card__media {
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  aspect-ratio: 16 / 10;
  overflow: hidden;
}

.psk-card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.35s ease;
}

.psk-card:hover .psk-card__img {
  transform: scale(1.03);
}

.psk-card__img--placeholder {
  min-height: 100%;
}

.psk-card__body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 6px;
  padding: 14px 14px 12px;
}

.psk-card__title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.psk-card__desc {
  margin: 0;
  flex: 1;
  font-size: 12px;
  line-height: 1.45;
  color: #888;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.9em;
}

.psk-card__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

.psk-card__bookmark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: #222;
  color: #a3a3a3;
  cursor: pointer;
  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}

.psk-card__bookmark:hover {
  color: #fff;
  background: #2a2a2a;
}

.psk-card__bookmark--on {
  color: #ff4d9a;
  border-color: rgba(255, 77, 154, 0.35);
}

.psk-card__try {
  flex: 1;
  height: 36px;
  border: 0;
  border-radius: 10px;
  background: #2a2a2a;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}

.psk-card__try:hover {
  background: #353535;
}
</style>
